import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { StaffTypeService } from "../report-services/staff-type.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./staffphotos4columns.component.html",
})
export class StaffPhotos4ColumnsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private stafftypeService: StaffTypeService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		STAFFTYPEID: 0,
		W_ID: "Yes",
		W_HPhoneID: "Yes",
		W_StaffTypeID: "Yes",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	STAFFTYPEList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	W_List = [
		//Insert Custom List Items Here
		{
			W_ID: "Yes",
			W_Name: "Yes",
		},
		{
			W_ID: "No",
			W_Name: "No",
		},
	];

	W_HPhoneList = [
		//Insert Custom List Items Here
		{
			W_HPhoneID: "Yes",
			W_HPhoneName: "Yes",
		},
		{
			W_HPhoneID: "No",
			W_HPhoneName: "No",
		},
	];

	W_StaffTypeList = [
		//Insert Custom List Items Here
		{
			W_StaffTypeID: "Yes",
			W_StaffTypeName: "Yes",
		},
		{
			W_StaffTypeID: "No",
			W_StaffTypeName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 235;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadSTAFFTYPEList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadSTAFFTYPEList();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(235);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadSTAFFTYPEList() {
		this.report.STAFFTYPEID = 0;
		var result = this.stafftypeService.loadSTAFFTYPEList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.STAFFTYPEList = response;

				if (this.STAFFTYPEList.length > 1) {
					// this.STAFFTYPEList.unshift({
					//     PersonTypeID: 0,
					//     PersonTypeDesc: "All STAFFTYPEs"
					// })
					this.report.STAFFTYPEID = this.STAFFTYPEList[0].PersonTypeID;
				} else {
					this.report.STAFFTYPEID = this.STAFFTYPEList[0].PersonTypeID;
				}
			},
			(error) => {}
		);
	}
	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.STAFFTYPEID) {
		// 	this.errorMessage = "Select the STAFFTYPE"
		// 	return;
		// }

		// if (!this.report.W_ID) {
		// 	this.errorMessage = "Select the W_"
		// 	return;
		// }

		// if (!this.report.W_HPhoneID) {
		// 	this.errorMessage = "Select the W_HPhone"
		// 	return;
		// }

		// if (!this.report.W_StaffTypeID) {
		// 	this.errorMessage = "Select the W_StaffType"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 235;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: STAFFTYPEID
		strParam += "," + this.report.STAFFTYPEID + "|STAFFTYPEID";

		//Parameter 3: W_ID
		strParam += "," + this.report.W_ID + "|W_ID";

		//Parameter 4: W_HPhone
		strParam += "," + this.report.W_HPhoneID + "|W_HPhone";

		//Parameter 5: W_StaffType
		strParam += "," + this.report.W_StaffTypeID + "|W_StaffType";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
